export const ARRAY_FILTER_PARAMS = [
  "contains",
  "notContains",
  "equals",
  "notEqual",
];
